import { ValueOf } from '@/types/util';

export const walletServiceStatus = {
  WAITING: '提供待ち',
  AVAILABLE: '提供中',
  CLOSED: '終了',
} as const;

export type WalletServiceStatusKey = keyof typeof walletServiceStatus;
export type WalletServiceStatusValue = ValueOf<typeof walletServiceStatus>;

export const walletServiceStatusKeys = Object.keys(walletServiceStatus) as WalletServiceStatusKey[];

/** v-select用items */
export const walletServiceStatusItems = walletServiceStatusKeys
  .map((key) => ({
    title: walletServiceStatus[key],
    value: key,
  }));
